import generic from './categories/generic'
import hr from './categories/hr'
import marketing from './categories/marketing'
import softwareDevelopment from './categories/software-development'
import projectManagement from './categories/project-management'
import productManagement from './categories/product-management'
import sales from './categories/sales'
import design from './categories/design'
import startup from './categories/startup'
import it from './categories/it'
import business from './categories/business'


export const templatesLibrary = [
    generic,
    projectManagement,
    softwareDevelopment,
    it,
    productManagement,
    startup,
    design,
    business,
    marketing,
    hr,
    sales
]